import { UrgentConcernStatusEnum } from "../../../services/api/types/shiftHandover/enums/UrgentConcernStatusEnum";
import { UrgentConcernModel } from "../../../services/api/types/shiftHandover/models/UrgentConcernModel";
import React from "react";
import { View } from "react-native";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { TrashIcon } from "ui/gluestack/icon";

type Props = {
  concern: UrgentConcernModel;
  isDeleting: boolean;
  isUpdating: boolean;
  onDelete: (id: number) => void;
  onUpdate: (id: number, status: UrgentConcernStatusEnum) => void;
};

const UrgentConcernActions: React.FC<Props> = ({
  concern,
  isDeleting,
  isUpdating,
  onDelete,
  onUpdate,
}) => {
  const effectiveId = concern.reportable_id ?? concern.id;
  return (
    <View className="flex-row gap-4 justify-end">
      <Button
        disabled={isDeleting || isUpdating}
        action="positive"
        variant="solid"
        size="sm"
        onPress={() => onUpdate(effectiveId, UrgentConcernStatusEnum.RESOLVED)}
      >
        <ButtonText>Complete</ButtonText>
      </Button>
      <Button
        disabled={isDeleting || isUpdating}
        action="negative"
        variant="outline"
        size="sm"
        onPress={() => onDelete(effectiveId)}
      >
        <ButtonIcon as={TrashIcon} />
      </Button>
    </View>
  );
};

export default UrgentConcernActions;
